import { css } from '@emotion/css';
import { TruckIcon } from '@heroicons/react/24/outline';
import { Colors } from '../styles/colors';
import { p1Style } from '../styles/text';

export const NoVehiclesYet = (): JSX.Element => {
  return (
    <div className={containerStyle}>
      <div className={iconWrapStyle}>
        <TruckIcon color={Colors.CAPRI_BLUE} className={imageStyle} />
      </div>
      <div className={textStyle}>Once added your vehicles will appear here</div>
    </div>
  );
};

const textStyle = css`
  ${p1Style}
  color: ${Colors.TEXT_SECONDARY};
  padding-top: 1.5rem;
`;

const iconWrapStyle = css`
  align-self: center;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background: ${Colors.SURFACE};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const imageStyle = css`
  height: 3rem;
  width: 3rem;
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  justify-self: center;
  height: 60vh;
  justify-content: center;
`;
